import { connect } from 'react-redux';
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import CenterModal from '@sendgrid/ui-components/center-modal';
import Button from '@sendgrid/ui-components/button';
import { isSignupEligible } from '../../actions/packages';

const mapStateToProps = (state) => {
  const { packages } = state;
  const { intendedEIPlan, intendedMCPlan } = packages;
  return {
    intendedEIPlan,
    intendedMCPlan,
  };
};

export const getIntendedPlansDisplay = (intendedEIPlan, intendedMCPlan) => {
  const intendedPlans = [intendedEIPlan, intendedMCPlan]
    .filter(offering => !isSignupEligible(offering))
    .filter(offering => offering && offering.display && offering.display.en_us)
    .map((offering) => {
      const displayName = offering.display.en_us;
      if (offering.name.includes('.ei.')) {
        return `Email API: ${displayName}`;
      }
      if (offering.name.includes('.mc.')) {
        return `Marketing Campaigns: ${displayName}`;
      }
      return '';
    })
    .join(' and ');
  return intendedPlans || 'your intended plan';
};

export const GetStartedModal = ({
  intendedEIPlan,
  intendedMCPlan,
}) => {
  const shouldShow = !isSignupEligible(intendedEIPlan) || !isSignupEligible(intendedMCPlan);
  const [isOpen, setIsOpen] = useState(shouldShow);
  const closeModal = useCallback(() => setIsOpen(false));
  const intendedPlans = getIntendedPlansDisplay(intendedEIPlan, intendedMCPlan);

  useEffect(() => {
    setIsOpen(shouldShow);
  }, [intendedEIPlan, intendedMCPlan]);

  return (
    <CenterModal
      open={isOpen}
      renderHeader="Get Started for Free"
      renderBody={(
        <p>
          No need to pull out your credit card. To enhance security for all of our users, we do not allow immediate upgrade upon signup. You&apos;ll be able to upgrade to {intendedPlans} in the application after approval.
        </p>
      )}
      renderFooter={(
        <Button onClick={closeModal}>
          Okay, got it
        </Button>
      )}
    />
  );
};

const oesOfferingType = PropTypes.shape({
  name: PropTypes.string,
  display: PropTypes.shape({ en_us: PropTypes.string }),
});

GetStartedModal.propTypes = {
  intendedEIPlan: oesOfferingType,
  intendedMCPlan: oesOfferingType,
};

GetStartedModal.defaultProps = {
  intendedEIPlan: undefined,
  intendedMCPlan: undefined,
};

export default connect(mapStateToProps)(GetStartedModal);
